// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2z5hy","ranges":"BmiRanges_ranges__1vDqC"};